import React from "react";

export default function Credentials() {
  return (
    <section className="section light-section" id="credentials">
      <div className="container">
        <div className="section-heading">
          <span className="section-label">Professional Credentials</span>
          <h2>Professional Positioning Built on Trust and Clarity</h2>
          <p>
            A professional translation service designed to present credibility,
            confidence and specialist focus for clients in the UK and beyond.
          </p>
        </div>

        <div className="credentials-grid">
          <div className="credential-card">
            <h3>Professional Standards</h3>
            <p>
              Translation work is presented with clarity, consistency and care,
              especially for documents requiring professional handling.
            </p>
          </div>

          <div className="credential-card">
            <h3>English to Arabic Focus</h3>
            <p>
              The website is positioned around a focused language pair to make
              the service clear and easy to understand for clients.
            </p>
          </div>

          <div className="credential-card">
            <h3>Suitable for Important Use</h3>
            <p>
              The service is suitable for legal, administrative, academic,
              commercial and personal documentation.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}